/**
 * Pinned byte-for-byte to cells D/E's client-side hash (S2,
 * create-metrics-event.tsx) so every cell's telemetry joins in analysis:
 * trim -> lowercase -> UTF-8 -> SHA-256 -> lowercase hex. Duplicated rather
 * than imported — `libs/auth/core` (`scope:auth`) cannot import
 * `libs/lawsuit/shared` (`scope:lawsuit`); the two implementations are held
 * equal by sharing the same test fixture, not by one calling the other.
 * `crypto.subtle` (WebCrypto), not Node's `crypto` module — this runs in the
 * browser, inside the login iframe.
 */
export async function entityNoticeContactHash(contact: string): Promise<string> {
  const normalized = contact.trim().toLowerCase()
  const data = new TextEncoder().encode(normalized)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
